import { Add, Notifications } from "@mui/icons-material";
import { Avatar, Box, Button, Card, CardContent, Chip, Typography, useTheme, Grid } from "@mui/material";
import { BulletinItem } from "../../utils/BulletinBoardAPIRequest";

interface BulletinBoardWebProps {
    bulletinMessages: BulletinItem[];
}

function BulletinBoardWeb({ bulletinMessages }: BulletinBoardWebProps) {
    const theme = useTheme();

    // Convert createdAt to relative time
    const getRelativeTime = (dateString: string) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

        if (diffInSeconds < 60) return 'just now';
        if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
        if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
        if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} days ago`;
        return `${Math.floor(diffInSeconds / 604800)} weeks ago`;
    };

    return (
        <Box>
            <Box
                display="grid"
                gap={3}
                sx={{
                    gridTemplateColumns: {
                        xs: '1fr',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(3, 1fr)'
                    }
                }}
            >
                {bulletinMessages.map((bulletin) => (
                    <Box key={bulletin._id}>
                        <Card
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                position: "relative",
                                overflow: "hidden",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    boxShadow: theme.shadows[4],
                                },
                                transition: "all 0.3s ease",
                                // "&::before": {
                                //     content: '""',
                                //     position: "absolute",
                                //     top: 0,
                                //     left: 0,
                                //     right: 0,
                                //     height: "4px",
                                //     background: `linear-gradient(90deg, 
                                //         ${theme.palette.primary.main}, 
                                //         ${theme.palette.secondary.main},
                                //         ${theme.palette.success.main}
                                //     )`
                                // }
                            }}
                        >
                            <CardContent sx={{ flex: 1, p: 2, pt: 3 }}>
                                <Box sx={{ display: "flex", mb: 1 }}>
                                    <Avatar sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}>
                                        <Notifications />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="h6" gutterBottom>
                                            {bulletin.title}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {getRelativeTime(bulletin.createdAt)}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    {bulletin.content}
                                </Typography>
                                {bulletin.createdBy && (
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 'auto' }}>
                                        Posted by: {bulletin.createdBy}
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default BulletinBoardWeb;